export default {
  spritzConfigs: {
    proxy: {
      name: 'CoreProxy',
      group: 'LINKUSD',
    },
    syntheticToken: {
      name: 'SyntheticToken',
      group: 'LINKUSD',
    },
    collateralAsset: {
      name: 'CollateralToken',
      group: 'LINKUSD',
    },
    oracle: {
      name: 'Oracle',
      group: 'LINKUSD',
    },
    state: {
      name: 'SpritzState',
      group: 'LINKUSD',
    },
  },
  rewardPools: [
    {
      name: 'Pool-1',
      pair: 'LINKUSD',
      platform: 'Balancer',
      pairLink:
        'https://pools.balancer.exchange/#/pool/0x5dcb5baa17a5af85aaec5d2b422cab13c0141bce/',
      note: 'Only available to KYF v1 users.',
    },
    {
      name: 'Pool-2',
      coreType: 'spritz',
      pair: 'LINKUSD',
      pairLink:
        'https://pools.balancer.exchange/#/pool/0x5dcb5baa17a5af85aaec5d2b422cab13c0141bce/',
      platform: 'Balancer',
      note: 'Only available to KYF v1 users.',
    },
    {
      name: 'Pool-2.1',
      pair: 'LINKUSD',
      platform: 'N/A',
      note: 'Only available to KYF v1 users.',
    },
    {
      name: 'Pool-3',
      pair: 'LINKUSD/3CRV',
      pairLink: 'https://www.curve.fi/linkusd',
      platform: 'Curve',
      note: 'Only available to KYF v1 users.',
    },
    {
      name: 'Pool-4',
      pair: 'LINKUSD/3CRV',
      pairLink: 'https://www.curve.fi/linkusd',
      platform: 'Curve',
      note: 'Available to Know Your Farmer users.',
    },
    {
      name: 'Pool-5',
      pair: 'UNIV2: USDC-STABLEx',
      pairLink: 'https://info.uniswap.org/pair/0x1bcce9e2fd56e8311508764519d28e6ec22d4a47',
      platform: 'Uniswap',
      // eslint-disable-next-line
      note: 'To learn more about how to participate in this farm, <a href="https://wiki.arcx.money/yield-farming" target="_blank" rel="noopener noreferrer">visit our wiki</a>.',
    },
    {
      name: 'Pool-6',
      pair: 'STABLEx3CRV',
      pairLink: 'https://app.arcx.money/exchange',
      platform: 'Curve',
      // eslint-disable-next-line
      note: 'To learn more about how to participate in this farm, <a href="https://wiki.arcx.money/yield-farming" target="_blank" rel="noopener noreferrer">visit our wiki</a>.',
    },
    {
      name: 'Pool-6.1',
      pair: 'STABLEx3CRV',
      pairLink: 'https://app.arcx.money/exchange',
      platform: 'Curve',
      // eslint-disable-next-line
      note: 'To learn more about how to participate in this farm, <a href="https://wiki.arcx.money/yield-farming" target="_blank" rel="noopener noreferrer">visit our wiki</a>.',
    },
    {
      name: 'Pool-7',
      pair: 'STABLEx3CRV',
      pairLink: 'https://app.arcx.money/exchange',
      platform: 'Curve',
    },
    {
      name: 'Pool-8',
      pair: 'STABLEx3CRV',
      pairLink: 'https://app.arcx.money/exchange',
      platform: 'Curve',
    },
    {
      name: 'Pool-9',
      pair: 'ETH/ARCX',
      pairLink: 'https://app.sushi.com/add/ETH/0x1321f1f1aa541A56C31682c57b80ECfCCd9bB288',
      platform: 'Sushiswap',
    },
  ],
  volatileCollaterals: ['LINK'],
  curvePool: {
    minimalPoolPartPercentage: '40',
    poolRegistryAddress: '0x0959158b6040D32d04c301A72CBFD6b39E21c9AE',
    poolAddress: '0x3252eFd4EA2d6c78091a1f43982ee2C3659cC3D1',
    depositZap: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
  },
}
